import { Box, Flex, FormNumberInput, ReadonlyField } from '@shared/components';

interface SeatFormFieldProps {
  endContent?: React.ReactNode;
  isSeatEditable?: boolean;
  seat?: string;
  disabled?: boolean;
}
export default function SeatFormField(props: Readonly<SeatFormFieldProps>) {
  const { endContent, isSeatEditable = true, seat, disabled } = props;

  return (
    <Flex
      sx={{
        gap: (theme) => theme.spacing(4),
        alignItems: isSeatEditable ? 'baseline' : 'flex-end',
      }}
    >
      {isSeatEditable ? (
        <FormNumberInput
          name='location.seat'
          label='จำนวนที่นั่ง'
          placeholder='กรุณากรอกจำนวนที่นั่ง'
          sx={{ maxWidth: '190px' }}
          required
          disabled={disabled}
        />
      ) : (
        <Box sx={{ width: '190px' }}>
          <ReadonlyField label='จำนวนที่นั่ง' content={seat ?? '0'} />
        </Box>
      )}
      {endContent}
    </Flex>
  );
}
